export function getTotalUnreadCount(
  role: string,
  visaAssistance: boolean,
  isAgent: boolean,
  unreadMessagesStudent: number,
  unreadMessagesUni: number,
  unreadMessagesStudentByUni: number,
  unreadMessagesUniToAgent: number,
  unreadMessagesStudentToAgent: number,
  unreadMessagesAgentToUni: number,
  unreadMessagesUniSecure: number,
  unreadMessagesUniByAgent: number,
  unreadMessagesUniByAdmin: number,
  unreadMessagesUniToStudentByAdmin: number,
  unreadMessagesUniToAgentByAdmin: number,
  unreadMessagesStudentToAgentByAdmin: number,
  unreadMessagesUniByPartner: number,
  unreadMessagesUniToStudentByPartner: number = 0,
  unreadMessagesUniByImmigrationProvider: number,
): number {
  switch (role) {
    case '[Uni]':
    case '[UniAdmin]':
    case '[UniLite]':
      if (visaAssistance || isAgent) {
        return unreadMessagesUni + unreadMessagesStudentByUni + unreadMessagesAgentToUni;
      }
      return unreadMessagesUni + unreadMessagesStudentByUni;
    case '[UniSecure]':
      if (visaAssistance || isAgent) {
        return unreadMessagesUni + unreadMessagesStudentByUni + unreadMessagesAgentToUni + unreadMessagesUniSecure;
      }
      return unreadMessagesUni + unreadMessagesStudentByUni + unreadMessagesUniSecure;
    case '[Enroly]':
    case '[Admin]':
      if (visaAssistance) {
        return (
          unreadMessagesUniToStudentByAdmin +
          unreadMessagesUniByAdmin +
          unreadMessagesUniToAgentByAdmin +
          unreadMessagesStudentToAgentByAdmin
        );
      }
      return unreadMessagesUniByAdmin + unreadMessagesUniToStudentByAdmin;
    case '[Agent]':
    case '[AgencyAdmin]':
      if (!visaAssistance && isAgent) {
        return (
          unreadMessagesStudent + unreadMessagesUniByAgent + unreadMessagesUniToAgent + unreadMessagesStudentToAgent
        );
      }
      return unreadMessagesUniByAgent + unreadMessagesStudent;
    case '[Partner]':
      return unreadMessagesUniByPartner + unreadMessagesUniToStudentByPartner;
    case '[ImmigrationProvider]':
      return unreadMessagesUniByImmigrationProvider;
    default:
      return unreadMessagesUni;
  }
}
